<template>
    <div class="dashboard">
        <header-navigation/>
        <div class="container" style="justify-content: center;">
            <div class="entireView centerItems">
                <img :src="require('@/assets/gomXchange.png')" alt="gomXchange logo" style="width: 65vw;">
                <h1 class="comingSoonText">Coming Soon</h1>
            </div>
        </div>
        <bottom-credits/>
    </div>
</template>

<script>
import HeaderNavigation from '../components/HeaderNavigation.vue';
import BottomCredits from '../components/BottomCredits.vue';

export default {
    components: {
        HeaderNavigation,
        BottomCredits
    }
}
</script>

<style lang="scss">
.centerItems {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.comingSoonText {
    font-size: 5vw;
}
</style>